const faqs = [
  {
    q: '番茄影视大全是否需要注册才能观看？',
    a: '无需注册，完全免费。打开番茄影视大全即可直接浏览和观看所有最新电视剧、热播剧集，没有任何观看门槛，也不需要付费订阅。',
  },
  {
    q: '网站支持哪些设备观看电视剧？',
    a: '番茄影视大全兼容电脑、平板和手机浏览器，无论您使用 Windows、Mac、iOS 还是 Android 设备，都能流畅在线看电视剧。推荐使用 Chrome 或 Safari 浏览器获得最佳高清体验。',
  },
  {
    q: '剧集更新速度快吗？会不会有缓冲？',
    a: '我们与各大平台同步更新，热门电视剧通常在播出后数小时内上线。采用多节点 CDN 加速技术，确保高清不缓冲的观看体验，即使高峰期也能流畅追剧。',
  },
  {
    q: '可以下载电视剧离线观看吗？',
    a: '番茄影视大全为在线观看平台，暂不支持下载功能。但您可以随时随地通过浏览器访问，只要有网络就能继续追剧，进度自动记忆，方便下次接着看。',
  },
  {
    q: '如果遇到播放问题该怎么办？',
    a: '如遇播放卡顿，建议切换清晰度或刷新页面。大部分问题可通过清除浏览器缓存解决。若仍有问题，欢迎通过页面底部的联系方式与我们沟通，我们会尽快处理。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">关于番茄影视大全，您可能想了解的内容</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/70 transition-colors">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}